export const CombinedShapeDanger = () => (
  <svg
    width="148"
    height="72"
    viewBox="0 0 148 72"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient x1="14.755%" y1="54.472%" x2="81.528%" y2="48.386%" id="n0puzln4fc">
        <stop stopColor="#ED0000" offset="0%" />
        <stop stopColor="#EB00A5" offset="100%" />
      </linearGradient>
      <filter
        x="-8.5%"
        y="-10.8%"
        width="116.9%"
        height="138.3%"
        filterUnits="objectBoundingBox"
        id="j1if3qmv1a"
      >
        <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.407843137 0 0 0 0 0.607843137 0 0 0 0 0.878431373 0 0 0 0.24 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <path
        d="M38 264c9.815 0 18.529 4.713 24.002 12H126c9.941 0 18 8.059 18 18s-8.059 18-18 18l-63.999.001C56.528 319.287 47.814 324 38 324c-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30z"
        id="111vlime0b"
      />
    </defs>
    <g transform="translate(-2 -263)" fill="none" fillRule="evenodd">
      <use fill="#000" filter="url(#j1if3qmv1a)" xlinkHref="#111vlime0b" />
      <use fill="url(#n0puzln4fc)" xlinkHref="#111vlime0b" />
    </g>
  </svg>
);
